import axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Toast } from 'react-bootstrap'; // Added for feedback
import SecurityHeaders from '../../data/SecurityHeaders';
import { AccountCircle } from '@material-ui/icons';
import ENDPOINT from '../../data/ENDPOINT';

const AddBounty = () => {
  const [image, setImage] = useState('');
  const [bountyTitle, setBountyTitle] = useState('');
  const [bountyDescription, setBountyDescription] = useState('');
  const [organizationId, setOrganizationId] = useState('');
  
  const [companyName, setCompanyName] = useState(''); // Changed to match backend
  const [p1, setP1] = useState(''); // New field
  const [p2, setP2] = useState(''); // New field
  const [p3, setP3] = useState(''); // New field
  const [p4, setP4] = useState(''); // New field
  const [payout, setPayout] = useState('');
  const [category, setCategory] = useState('');
  const [link, setLink] = useState('');
  const [uploadedDate, setUploadedDate] = useState(''); // New field, optional
  const [startDate, setStartDate] = useState('');
  const [status, setStatus] = useState('');
  const [techStack, setTechStack] = useState('');
  const [deadline, setDeadline] = useState('');
  const [rating, setRating] = useState('');
  const [toast, setToast] = useState(false); // For feedback
  const [toastMessage, setToastMessage] = useState('');


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };


  const addBounty = async (e) => {
    e.preventDefault();
    const data = new FormData();

    data.append('image', image);
    data.append('bounty_title', bountyTitle);
    data.append('bounty_description', bountyDescription);
    data.append('organization_id', organizationId);

    data.append('company_name', companyName); // Changed to match backend
    data.append('p1', p1 || '0'); // Default to 0 if empty
    data.append('p2', p2 || '0'); // Default to 0 if empty
    data.append('p3', p3 || '0'); // Default to 0 if empty
    data.append('p4', p4 || '0'); // Default to 0 if empty
    data.append('payout', payout || '0');
    data.append('category', category);
    data.append('link', link);
    data.append('uploaded_date', uploadedDate || ''); // Optional, backend defaults to NOW()
    data.append('start_date', startDate);
    data.append('status', status);
    data.append('tech_stack', techStack);
    data.append('deadline', deadline);
    data.append('rating', rating || '0');

    try {
      const res = await axios.post(`${ENDPOINT}add-bounty.php`, data, SecurityHeaders);

      if (res.data.status === 'success') {
        setToastMessage('Bounty added successfully!');
        setToast(true);
        // Reset form
        setImage('');
        setBountyTitle('');
        setBountyDescription('');
        setOrganizationId('');
 
        setCompanyName('');
        setP1('');
        setP2('');
        setP3('');
        setP4('');
        setPayout('');
        setCategory('');
        setLink('');
        setUploadedDate('');
        setStartDate('');
        setStatus('');
        setTechStack('');
        setDeadline('');
        setRating('');
      } else {
        setToastMessage(res.data.message || 'Error adding bounty');
        setToast(true);
      }
    } catch (error) {
      setToastMessage('Error while uploading data: ' + error.message);
      setToast(true);
    }
  };

  return (
    <div>
      <div className="position-fixed bottom-0 start-50 translate-middle-x w-100 d-flex justify-content-center">
        <Toast
          className="bg-warning"
          onClose={() => setToast(false)}
          show={toast}
          delay={3000}
          autohide
        >
          <Toast.Header className="bg-warning text-dark">
            <strong className="me-auto">{toastMessage}</strong>
          </Toast.Header>
        </Toast>
      </div>

      <div className="d-flex justify-content-center py-5">
        <div className="card col-12 col-lg-8 col-sm-12 col-md-8 p-4 shadow rounded-3">
          <h2 className="mb-3 text-primary">Add Bounty</h2>
          <form onSubmit={addBounty}>
            <div className="mb-3">
              <label htmlFor="image" className="form-label">Image URL</label>
            <div
                            style={{
                              height: 90,
                              width: 90,
                              borderRadius: '50%',
                              overflow: 'hidden',
                              cursor: 'pointer',
                              display: 'inline-block',
                              backgroundColor: '#f0f0f0',
                              backgroundImage: image ? `url(${URL.createObjectURL(image)})` : 'none',
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                            }}
                            onClick={() => {
                              const input = document.createElement('input');
                              input.type = 'file';
                              input.accept = 'image/*';
                              input.onchange = handleFileChange;
                              input.click();
                            }}
                          >
                            {!image && (
                              <AccountCircle style={{ height: '100%', width: '100%', color: '#ccc' }} />
                            )}
                          </div>
            </div>

            <div className="mb-3">
              <label htmlFor="bounty_title" className="form-label">Bounty Title</label>
              <input
                type="text"
                className="form-control"
                value={bountyTitle}
                onChange={(e) => setBountyTitle(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="bounty_description" className="form-label">Description</label>
              <textarea
                className="form-control"
                value={bountyDescription}
                onChange={(e) => setBountyDescription(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="organization_id" className="form-label">Organization ID</label>
              <input
                type="number"
                className="form-control"
                value={organizationId}
                onChange={(e) => setOrganizationId(e.target.value)}
                required
              />
            </div>

       

            <div className="mb-3">
              <label htmlFor="company_name" className="form-label">Company Name</label>
              <input
                type="text"
                className="form-control"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="p1" className="form-label">P1 </label>
              <input
                type="number"
                className="form-control"
                value={p1}
                onChange={(e) => setP1(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="p2" className="form-label">P2 </label>
              <input
                type="number"
                className="form-control"
                value={p2}
                onChange={(e) => setP2(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="p3" className="form-label">P3 </label>
              <input
                type="number"
                className="form-control"
                value={p3}
                onChange={(e) => setP3(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="p4" className="form-label">P4 </label>
              <input
                type="number"
                className="form-control"
                value={p4}
                onChange={(e) => setP4(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="payout" className="form-label">Payout </label>
              <input
                type="number"
                className="form-control"
                value={payout}
                onChange={(e) => setPayout(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="category" className="form-label">Category</label>
              <input
                type="text"
                className="form-control"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="link" className="form-label">Link</label>
              <input
                type="text"
                className="form-control"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="uploaded_date" className="form-label">Uploaded Date (Optional)</label>
              <input
                type="datetime-local"
                className="form-control"
                value={uploadedDate}
                onChange={(e) => setUploadedDate(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="start_date" className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="status" className="form-label">Status</label>
              <select
                className="form-control"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                required
              >
                <option value="">Select Status</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
                <option value="in-progress">In Progress</option>
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="tech_stack" className="form-label">Tech Stack</label>
              <input
                type="text"
                className="form-control"
                value={techStack}
                onChange={(e) => setTechStack(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="deadline" className="form-label">Deadline</label>
              <input
                type="date"
                className="form-control"
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="rating" className="form-label">Rating (1-5, Optional)</label>
              <input
                type="number"
                className="form-control"
                min="1"
                max="5"
                value={rating}
                onChange={(e) => setRating(e.target.value)}
              />
            </div>

            <button type="submit" className="btn btn-primary">Add Bounty</button>
            <Link to="/company-dashboard" className="btn btn-secondary ms-2">Cancel</Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddBounty;